export default __webpack_public_path__ + "static/media/Synoptic Consulting.c24f7770.png";